import { safeLocalStorageProvider } from './../../providers/safeLocalStorageProvider'
import { warn } from './../../application/console'
import { get as getCookie } from '../../utils/cookies'

const STORAGE_KEY = 'CurrentUser'
export const LOGGED_IN_COOKIE_NAME = 'logged_in'
export const ROLES = {
  EDITOR: 'editor',
  ADMIN: 'admin',
  AUTHOR: 'author',
}

export class CurrentUser {
  get() {
    let currentUser = {}

    try {
      currentUser = safeLocalStorageProvider.get(STORAGE_KEY, {})
    } catch (e) {
      warn('failed loading/parsing user data from localStorage', e)
    }

    return currentUser
  }

  getRole(postAuthorId) {
    let currentUser = this.get()
    if (this.isLoggedIn) {
      if (currentUser.admin || currentUser.super_admin) {
        return ROLES.ADMIN
      } else if (currentUser.editor || this.roleViaCookie(ROLES.EDITOR)) {
        return ROLES.EDITOR
      } else if (currentUser.id === postAuthorId) {
        return ROLES.AUTHOR
      }
    }
    return null
  }

  roleViaCookie(role) {
    const loginCookie = getCookie(LOGGED_IN_COOKIE_NAME)
    if (loginCookie == null) {
      return false
    }
    try {
      return JSON.parse(loginCookie).role == role
    } catch (err) {
      this.warn('Cookie authentication failed', err)
      return false
    }
  }

  get isLoggedIn() {
    const currentUser = this.get()
    const userDataInLocalStorage = currentUser && currentUser.authenticated
    const loginCookie = getCookie(LOGGED_IN_COOKIE_NAME)
    if (!userDataInLocalStorage && loginCookie == null) {
      return false
    }
    return true
  }

  set(data) {
    safeLocalStorageProvider.set(STORAGE_KEY, data)
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/providers/currentUser/index.js